import { render, staticRenderFns } from "./CompensatoryApproval.vue?vue&type=template&id=6fb2adf9&"
import script from "./CompensatoryApproval.vue?vue&type=script&lang=js&"
export * from "./CompensatoryApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports